import layout from '@/layout'

export default {
  path: '/advance_fund',
  component: layout,
  redirect: '/advance_fund/car/index',
  name: 'advance_fund_car_index',
  meta: {
    title: 'advance_fund',
    icon: 'el-icon-document'
  },
  children: [
    {
      path: '/advance_fund/car/index',
      name: 'advance_fund_car_index',
      component: () => import('@/views/car_advance_fund/index'),
      meta: {
        title: 'advance_fund_car_index',
        icon: 'el-icon-document'
      }
    }
  ]
}
